module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_12.ca248b64.png";